/**
 * Definiert die vier Authentifizierungsmodi eines Events.
 *
 * NONE           – Kein Login erforderlich. Nutzer wird direkt zur HomeComponent weitergeleitet.
 * EMAIL_TOKEN    – Nur E-Mail erforderlich. Nutzer erhält eine Bestätigungs-Mail mit Login-Token.
 * EMAIL_PASSWORD – E-Mail/Benutzername + Passwort erforderlich.
 *                  Interne Nutzer (int) können den Login überspringen,
 *                  externe Nutzer (ext) müssen sich einloggen.
 * MEDIA_LIBRARY  – Login über einen Mediathek-Token (z. B. aus Query-Parameter).
 */
export enum AuthMode {
  NONE = 'none',
  EMAIL_TOKEN = 'email_token',
  EMAIL_PASSWORD = 'email_password',
  MEDIA_LIBRARY = 'media_library'
}
